import { render, staticRenderFns } from "./document.vue?vue&type=template&id=62ea1515&scoped=true&lang=pug&"
import script from "./document.vue?vue&type=script&lang=ts&"
export * from "./document.vue?vue&type=script&lang=ts&"
import style0 from "./document.vue?vue&type=style&index=0&id=62ea1515&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ea1515",
  null
  
)

export default component.exports